/* eslint-disable max-len */
/**
 * Spanish translations.
 */
export default {
  ACTION: {},
  ERROR: {
    FETCH_ATTACHMENTS: 'Obtener archivos adjuntos'
  },
  HEADER: {
    DATE: 'Fecha',
    SENT_BY_F: 'Enviado por',
    TITLE: 'Título'
  },
  LABEL: {
    ATTACHMENTS: 'Archivos adjuntos',
    DATE: 'Fecha',
    DETAIL: 'Detalle',
    MESSAGE: 'Mensaje',
    NO_ROWS_COMMUNICATIONS: 'Sin comunicaciones',
    SENT_BY_F: 'Enviado por',
    TITLE: 'Título',
    UNREAD: 'No leída'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
